import { types } from "../types/types";
import { persistUserCompanySelection } from "../../utils/selectedCompanySync";

export const getCompanyList = (values) => ({
  type: types.getCompanyList,
  payload: values,
});

export const importCompanyList = (companiesByUser) => {
  return async (dispatch) => {
    try {
      dispatch(getCompanyList(companiesByUser));
    } catch (error) {
      console.error(error);
    }
  };
};

export const getSelectedCompany = (values) => ({
  type: types.selectedCompany,
  payload: values,
});

/**
 * @param {object} company - selected company payload
 * @param {{ userInitiated?: boolean }} [options] - if true, persist id + BroadcastChannel (UI picker only)
 */
export const importSelectedCompany = (company, options = {}) => {
  return async (dispatch) => {
    try {
      dispatch(getSelectedCompany(company));
      if (options.userInitiated && company?.id) {
        persistUserCompanySelection(company.id);
      }
    } catch (e) {
      console.error(e);
    }
  };
};

export const getLoadingState = (values) => ({
  type: types.getLoadingState,
  payload: values,
});

export const importLoadingState = (loading) => {
  return async (dispatch) => {
    try {
      dispatch(getLoadingState(loading));
    } catch (e) {
      console.error(e);
    }
  };
};

export const getUpdateCompanyNeeded = (values) => ({
  type: types.getUpdateCompanyNeeded,
  payload: values,
});

export const importUpdateCompanyNeeded = (values) => {
  return async (dispatch) => {
    try {
      dispatch(getUpdateCompanyNeeded(values));
    } catch (error) {
      console.error(error);
    }
  };
};

export const setReportGroupCompanyIds = (values) => ({
  type: types.setReportGroupCompanyIds,
  payload: Array.isArray(values) ? values : [],
});

export const importReportGroupCompanyIds = (values) => {
  return async (dispatch) => {
    try {
      dispatch(setReportGroupCompanyIds(values));
    } catch (error) {
      console.error(error);
    }
  };
};

export const setExcludeIntercompanyReports = (value) => ({
  type: types.setExcludeIntercompanyReports,
  payload: Boolean(value),
});

export const importExcludeIntercompanyReports = (value) => {
  return async (dispatch) => {
    try {
      dispatch(setExcludeIntercompanyReports(value));
    } catch (error) {
      console.error(error);
    }
  };
};